export default function UbicacionSection() {
  const direccion = 'Presidente Carlos Ibáñez 0290, esquina Ejército, Coyhaique, Chile';
  const telefono = '+56 9 9434 7092';
  const mapsUrl = 'https://maps.google.com/maps?q=La+Casona+de+Don+Juan,+Presidente+Carlos+Ib%C3%A1%C3%B1ez,+Ej%C3%A9rcito,+Coyhaique,+Chile&output=embed&z=17';
  const mapsDirectUrl = 'https://maps.app.goo.gl/8ZMAi9cR2YMTNUvT6';

  return (
    <section id="ubicacion" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-stone-800 mb-4">
            Ubicación
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Encuéntranos en el corazón de Coyhaique, Patagonia Chilena
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Mapa */}
          <div className="w-full h-96 rounded-2xl overflow-hidden">
            <iframe
              src={mapsUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación Cafetería Boutique La Casona"
            ></iframe>
          </div>

          {/* Información */}
          <div className="space-y-8">
            <div className="bg-stone-50 p-8 rounded-2xl">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 text-amber-700 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-stone-800 mb-2 text-lg">Dirección</h3>
                  <p className="text-stone-600">{direccion}</p>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 text-amber-700 rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-stone-800 mb-2 text-lg">Teléfono</h3>
                  <p className="text-stone-600">{telefono}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 text-amber-700 rounded-full flex-shrink-0">
                  <i className="ri-time-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-stone-800 mb-2 text-lg">Horario Cafetería</h3>
                  <p className="text-stone-600">Lunes a Domingo: 9:00 - 20:00</p>
                </div>
              </div>
            </div>

            {/* Botones de Acción */}
            <div className="space-y-4">
              <a
                href={mapsDirectUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full bg-amber-600 hover:bg-amber-700 text-white px-6 py-4 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-navigation-line text-xl"></i>
                Cómo Llegar
              </a>
              <a
                href={`tel:${telefono.replace(/\s/g, '')}`}
                className="flex items-center justify-center gap-2 w-full bg-stone-700 hover:bg-stone-800 text-white px-6 py-4 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Llamar Ahora
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
